import { render, staticRenderFns } from "./SynaqWizard.vue?vue&type=template&id=73ea9671&"
import script from "./SynaqWizard.vue?vue&type=script&lang=js&"
export * from "./SynaqWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports